import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const DiscountCreationUnavailableMessages = ({ message = { monthlyBudgetReached: false, monthlyNumberReached: false } }) => {
  if (message.monthlyNumberReached) {
    return <FormattedMessage id="silverVoucher.monthlyMaxNumber" />;
  }

  return <FormattedMessage id="silverVoucher.monthlyMaxBudget" />;
};

DiscountCreationUnavailableMessages.propTypes = {
  message: PropTypes.shape({
    monthlyBudgetReached: PropTypes.bool,
    monthlyNumberReached: PropTypes.bool
  })
};

export default DiscountCreationUnavailableMessages;
